module.exports = __webpack_public_path__ + "fonts/OpenSans-ExtraBoldItalic.a9dce97c.woff";